import {activeMatchmakingMatchTypes} from '../../../shared/matchmaking/MatchmakingEnums'
import {UIUrlParameterNames} from '../../shared/scripts/ui_html/UIUrlController'
import {UIEntryUrlParameterController} from '../../shared/scripts/UIEntryUrlParameterController'
import {uiManager} from './EntryMobile'
import {clientIntl} from '../../shared/scripts/ClientI18n'
import {SocketLobbySend} from '../../shared/scripts/socket/SocketLobbySend'
import {UIMSceneEnum} from '../../../shared/enums/UIMSceneEnums'
import {MatchmakingMatchTypes, MatchType} from '@colonist/game-base-types'
import {AjaxDataTypes} from '../../../shared/AjaxDataTypes'
import {AnalyticEventCategory, AnalyticEventType, ReactivationTypeEnum, MobileImageSharingAnalytics} from '../../../shared/entity_datas/EntityDatas'
import {CA} from '../../shared/scripts/analytics/Analytics'
import {ClientShuffleQueueController} from '../../shared/scripts/shuffle/ClientShuffleQueueController'
import {ReferralProgramUtils} from '../../shared/scripts/referral/ReferralProgramUtils'

export class EntryMobileUrlParameterController extends UIEntryUrlParameterController {
    static loadParameterEvents() {
        const urlParams = new URLSearchParams(window.location.hash.replace(/^#/, ''))
        for(const parameterName of urlParams.keys()) {
            const parameterValue = urlParams.get(parameterName)
            if(parameterValue == null) continue
            switch(parameterName as UIUrlParameterNames) {
                case UIUrlParameterNames.MobileLeaderboard: this.loadScene(UIMSceneEnum.Leaderboard); this.removeParameter(); break
                case UIUrlParameterNames.MobileLobby: this.loadScene(UIMSceneEnum.Lobby); this.removeParameter(); break
                case UIUrlParameterNames.MobileHomepage: this.loadScene(UIMSceneEnum.Homepage); this.removeParameter(); break
                case UIUrlParameterNames.MobileStore: this.loadScene(UIMSceneEnum.Store); this.removeParameter(); break
                case UIUrlParameterNames.MobileProfile: this.loadScene(UIMSceneEnum.Profile); this.removeParameter(); break
                case UIUrlParameterNames.Campaign: this.loadCampaignMode(parameterValue); this.removeParameter(); break
                case UIUrlParameterNames.EnterMatchmaking: void this.loadMatchmakingQueue(parameterValue); this.removeParameter(); break
                case UIUrlParameterNames.EnterBotGame: this.loadEnterBotGame(); this.removeParameter(); break
                case UIUrlParameterNames.SelectMode: this.loadModeSelection(parameterValue); this.removeParameter(); break
                case UIUrlParameterNames.SuppressPopupsOnLoad: this.handleSuppressPopups(parameterValue); this.removeParameter(); break
                case UIUrlParameterNames.MobileReactivation: this.handleMobileReactivation(parameterValue); this.removeParameter(); break
                case UIUrlParameterNames.ReferralInvitation: void ReferralProgramUtils.processReferralInvitation(parameterValue); this.removeParameter(); break
                default: break
                case UIUrlParameterNames.MobileImageSharing: this.handleMobileImageSharing(parameterValue); this.removeParameter(); break
            }
        }
    }

    static removeParameter() {
        const pathPrefix = clientIntl.getLanguagePathPrefix() || ''
        const url = pathPrefix + '/mobile'
        window.history.replaceState({}, document.title, url)
    }

    static loadScene(scene: UIMSceneEnum) {
        uiManager.sceneController.loadScene(scene)
    }

    static loadCampaignMode(parameter: string) {
        if(parameter != this.DEFAULT_PARAMETER_VALUE) return

        void SocketLobbySend.continueCampaignMode()
    }

    static async loadMatchmakingQueue(parameter: string) {
        const matchType = Number(parameter) as MatchmakingMatchTypes
        if(!activeMatchmakingMatchTypes.has(matchType)) return

        if(matchType == MatchmakingMatchTypes.UnrankedShuffle) await ClientShuffleQueueController.waitForShuffleQueueData()

        void uiManager.mainpageController.bodyController.homepageController.matchmakingController.startGame(matchType)
    }

    static loadEnterBotGame() {
        void SocketLobbySend.clickedStartHardBotGame()
    }

    static loadModeSelection(parameter: string) {
        const matchType = parameter as MatchType
        void uiManager.goToMainPageAndSelectMatchType(matchType)
    }

    static handleSuppressPopups(parameter: string) {
        if(parameter != this.DEFAULT_PARAMETER_VALUE) return

        UIEntryUrlParameterController.suppressPopupsOnLoad = true
    }

    static handleMobileReactivation(parameter: string) {
        const eventDataMobileReactivation: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.ReactivationAnalytics,
            category: AnalyticEventCategory.MobilePushNotificationOpened,
            floatValue: Number(ReactivationTypeEnum[parameter]),
        }
        void CA.sendAnalyticEvent(eventDataMobileReactivation)
    }

    static handleMobileImageSharing(parameter: string) {
        const eventDataMobileSharing: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.ReferralAnalytics,
            category: AnalyticEventCategory.MobileImageSharing,
            floatValue: Number(MobileImageSharingAnalytics[parameter]),
        }
        void CA.sendAnalyticEvent(eventDataMobileSharing)
    }
}
